import { FC } from 'react';

import { useSelector } from 'react-redux';

import { Link } from 'react-router-dom';

import { useNews } from 'hooks/useNews';
import { usePageTitle } from 'hooks/usePageTitle';

import IconContact from 'images/icon/contact.svg';
import IconInfo from 'images/icon/info.svg';
import IconInfoAlert from 'images/icon/info_alert.svg';
import IconNews from 'images/icon/news.svg';
import IconStory from 'images/icon/story.svg';
import { RootState } from 'store';
import { isLatestNews } from 'utils/isLatestNews';
import IconEnding from 'images/icon/story-ending.svg';

import styles from './Menu.module.scss';
import { useGetProgressData } from 'hooks/useGetProgressData';
import { cx } from 'utils/cx';
export const Menu: FC = () => {
  const { website, support, hint } = useSelector((state: RootState) => state.external);
  const { data: progressData } = useGetProgressData();
  const newsData = useNews();
  const hasLatestNews = newsData
    ? Object.values(newsData).some(news => isLatestNews(news.date))
    : false;
  usePageTitle(`メニュー`);
  const isAllAreasCleared = progressData?.completedAreaList.length === 19;

  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        <div className={styles.body}>
          <ul className={styles.nav}>
            <li className={styles.navItem}>
              <Link to="/play?redirect=menu" className={styles.navLink}>
                <div className={styles.navHead}>
                  <img src={IconInfo} alt="" className={styles.navHeadIcon} />
                </div>
                <p className={styles.navBody}>楽しみ方ガイド</p>
              </Link>
            </li>
            <li className={styles.navItem}>
              <Link to="/menu/news" className={styles.navLink}>
                <div className={styles.navHead}>
                  <img src={IconNews} alt="" className={styles.navHeadIcon} />
                </div>
                <p className={styles.navBody}>お知らせ</p>
                {hasLatestNews && (
                  <img src={IconInfoAlert} alt="新着" className={styles.navLatest} />
                )}
              </Link>
            </li>
            <li className={styles.navItem}>
              <Link to="/story?redirect=menu" className={styles.navLink}>
                <div className={styles.navHead}>
                  <img src={IconStory} alt="" className={styles.navHeadIcon} />
                </div>
                <p className={styles.navBody}>ストーリー</p>
              </Link>
            </li>
            <li className={cx(styles.navItem, !isAllAreasCleared && styles['--disabled'])}>
              <Link to="/ending" className={styles.navLink}>
                <div className={styles.navHead}>
                  <img src={IconEnding} alt="" className={styles.navHeadIcon} />
                </div>
                <p className={styles.navBody}>エンディング</p>
              </Link>
            </li>
            <li className={styles.navItem}>
              <a href={support} target="_blank" rel="noreferrer" className={styles.navLink}>
                <div className={styles.navHead}>
                  <img src={IconContact} alt="" className={styles.navHeadIcon} />
                </div>
                <p className={styles.navBody}>問合せ</p>
              </a>
            </li>
            <li className={styles.navItem}>
              <a href={website} target="_blank" rel="noreferrer" className={styles.navLink}>
                <div className={styles.navHead}>
                  <img src={require('images/logo.webp')} alt="" className={styles.navHeadIcon} />
                </div>
                <p className={styles.navBody}>公式サイト</p>
              </a>
            </li>
          </ul>
        </div>
        <div className={styles.foot}>
          <p className={styles.footText}>
            サポートが必要な場合、以下のリンク先の画面をスクリーンショットし、画像を添付してお問い合わせください。
          </p>
          <Link to="/menu/info" className={styles.footLink}>
            システム情報を確認する
          </Link>
        </div>
      </div>
    </div>
  );
};
